export default "<ion-content>\n  <canvas id=\"st\"  width=\"800\" height=\"450\"></canvas>\n  </ion-content>\n";